<template>
  <router-link :to="{ name: 'Studio', params: { slug: string_to_slug(uni.name), id:uni.id, studio:uni.name, homepage:uni.homepage, description:uni.description }}" @click.native="goPage(uni)" class="info-card">
    <div class="info-card__top">
      <img :src="'http://image.tmdb.org/t/p/w185' + uni.logo_path" alt="studio movies" class="info-card__logo">
      <h3 class="info-card__name">{{ uni.name }}</h3>
      <!-- <h3 class="info-card__name">{{ uni.headquarters }}</h3> -->
    </div>
    <!--<div class="info-card__bottom">-->
      <!--<div class="info-card__title">Kayıtlı Öğrenci Yurdu</div>-->
      <!--<div class="info-card__count">{{ uni.dorms[0].aggregate }}</div>-->
    <!--</div>-->
  </router-link>

</template>

<script>
import Utility from '../common'
export default {
  name: 'UniCard',
  props: {
    uni: Object
  },
  methods: {
    goPage(uni) {
     window.localStorage.setItem('faculty_id', '')
     window.localStorage.setItem('faculty_name', '')
     window.localStorage.setItem('studio', this.uni.name)
     window.localStorage.setItem('studioId', this.uni.id)
     window.localStorage.setItem('logo_path', this.uni.logo_path)
     window.localStorage.setItem('description', this.uni.description)
     // let route = { name: 'University', params: { slug: uni.slug }}
     // this.$router.push(route)      
    },
        string_to_slug (str) {
          return Utility.string_to_slug(str)
    },     
  }  
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/info-card";
</style>
